import { Box } from "@mui/material";
// import Header from "./header";
import LayoutComponent from "./layout";

const StaffAndPlantComponent = (props) => {
    const { 
        data, 
        loader, 
        active, 
        selectType, 
        selectItem, 
        setSelectItem, 
        isSelect, 
    } = props;
    
    const { 
        staffData, 
        plantData, 
        // projectList, 
        currentProject 
    } = data;
    
    return (
        <Box px={4} py={2}>
            <LayoutComponent 
                loader={loader}
                staffData={staffData}
                plantData={plantData}
                project_name={currentProject}
                currentProject={currentProject}
                selectItem={selectItem}
                setSelectItem={setSelectItem}
                selectType={selectType}
                isSelect={isSelect}
                active={active}
            />
        </Box>
    )
}

export default StaffAndPlantComponent;